import { Container, Graphics, Texture, Sprite, Rectangle } from 'pixi.js';

import TweenLite from 'gsap/TweenLite';
import TimelineLite from 'gsap/TimelineLite';
import { RoughEase } from 'gsap/EasePack';

import config from './config';
import events from '../../../utils-and-data/events';

class BackgroundGhost extends Container {
  constructor(props, slice) {
    super();
    this.slice = slice;
    this.config = config[this.slice];
    this.props = props;
    const { width, height } = this.props.dimensions;
    this.alpha = 0;
    this.frame = this.createRect({ width, height }, 0x222222);
    this.addChild(this.frame);
    events.on('imageLoaded', this.imageLoaded);
    this.init();
  }

  imageLoaded = () => {
    this.init();
  }

  init() {
    // console.log('BackgroundGhost init()')
    this.cacheAsBitmap = false;
    // load Image
    if (!window.userMediaImg || window.userMediaImg.length == 0) console.log('BackgroundGhost NO IMAGE INSIDE window.userMediaImg')
    this.image = new Image();
    this.image.onload = () => {

      // console.log('BackgroundGhost image loaded()')
      const scaled = this.step1();
      const sliced = this.step2(scaled);
      this.step3(sliced);
    };
    this.image.crossOrigin = "Anonymous";
    this.image.src = window.userMediaImg;
  }

  _destroy() {
    events.removeListener('imageLoaded', this.imageLoaded);
    TweenLite.killTweensOf(this);
    this.destroy({ children:true, texture:true, baseTexture:true });
    while (this.children[0]) this.removeChild(this.children[0]);
  }

  show() {
    // console.log('BackgroundGhost show()')
    // this.cacheAsBitmap = true;
    this.alpha = 1;
  }

  animatedShow(onCompleteFn, dly=0) {
    // console.log('BackgroundGhost animatedShow()')
    TweenLite.to(this, 1, { alpha: 1, delay: dly, onComplete: () => {
      this.cacheAsBitmap = true;
      onCompleteFn();
    }});
  }

  flickerShow(onCompleteFn) {
    console.log('BackgroundGhost flickerShow()')
    this.tl = new TimelineLite({
      paused: true,
      onComplete: () => {
        onCompleteFn();
        TweenLite.to(this, 1, { alpha: 1 });
        console.log('flickering complete!');
      }
    });
    this.tl.to(this, 2.3, {
      alpha: 0.5,
      ease: RoughEase.ease.config({strength: 5, points: 100, randomize: true}),
      yoyo: true
    });
    this.tl.play();
  }


  step1() {
    console.log('BackgroundGhost step1()')
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    const { width, height } = this.props.dimensions;
    const s = this.getSize(width, height, this.image.width, this.image.height);

    canvas.width = s.w;
    canvas.height = s.h;
    ctx.drawImage(
      this.image,
      0, 0,
      s.w, s.h
    );

    // @TEMP:
    // Object.assign(canvas.style, {
    //   opacity: 0.5, position: 'absolute',
    //   top: 0, left: 0, width: '100%', zIndex: 5,
    // });
    // document.body.appendChild(canvas);
    return canvas;
  }

  step2(cnv) {
    console.log('BackgroundGhost step2()')
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    const { width, height } = this.props.dimensions;

    canvas.width = width;
    canvas.height = height;

    const p = this.getPos(width, height, cnv.width, cnv.height, this.config.align);
    // console.log('----------------------- STEP-2 - pos:', p);
    ctx.drawImage(
      cnv,
      p.x, p.y,
      width, height,
      0, 0,
      width, height
    );

    ctx.globalCompositeOperation = 'destination-in';
    this.createRadial(this.config.mask, ctx);

    cnv = null;
    return canvas;

  }

  step3(cnv) {
    console.log('BackgroundGhost step3()')
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    const { width, height } = this.props.dimensions;

    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(cnv, 0, 0);
    this.createRadial(this.config.halo, ctx);
    const texture = Texture.fromCanvas(canvas);
    const bakedImage = new Sprite(texture);

    cnv = null;
    this.addChild(bakedImage);
  }

  createRadial(c, ctx) {
    const { width, height } = this.props.dimensions;
    const r = (c.radius * width);
    const px = width * c.x;
    const py = height * c.y;

    const radial = ctx.createRadialGradient(
      px, py, r, // Outer circle
      px, py, 0 // Inner circle
    );

    radial.addColorStop(0, 'rgba(247,209,155, 0)');
    radial.addColorStop(1, 'rgba(247,209,155, 1)');

    ctx.fillStyle = radial;
    ctx.fillRect(0, 0, width, height);
  }

  getSize(screenW, screenH, imageW, imageH) {
    let h = screenH;
    let w = imageW * (h/imageH);

    return { w, h }
  }

  getPos(screenW, screenH, imageW, imageH, pos) {
    let x = 0;
    let y = 0;

    if (pos == 'right') {
      x = imageW - screenW
      y = imageH - screenH
    }

    return { x, y }
  }

  createRect(size, color) {
    const bg = new Graphics();
    bg.beginFill(color, 1);
    bg.drawRect(0, 0, size.width, size.height);
    bg.endFill()
    return bg;
  }
}

export default BackgroundGhost;



// WEBPACK FOOTER //
// ./app/frontend/components/animations/background/index.js